import { makeStyles } from "@material-ui/styles"

const useStyle = makeStyles((theme) => ({
  rowGroup: {
    width: "initial",
    /** @note: this was here for some reason: */
    // "&.timeline": {
    //   width: "max-content"
    // },
    "&:not(.d1)": { border: "none !important" },
    "&:not(.static) > div[role='row']": {
      cursor: "pointer",
    },
    "&.d0": { margin: "4px 0" },
    "&.d1": { margin: "2px 0" },
    "&.d0, &.d1": { borderRadius: 5 },
    // "&:not(.d0):hover": {
    //   boxShadow: " 0px 1px 2px rgba(0, 0, 0, 0.15)",
    // },
    // border colors
    "& .d0 > .cell": { borderColor: "transparent" },
    "& .d0.descriptionRowContainer, & .d0.descriptionRowContainer > .descriptionRow": { borderColor: "transparent" },
    "&:not(.timeline) .d1 > .cell": { borderColor: theme.props.border },
    "&:not(.timeline) .d1.descriptionRowContainer": { borderColor: theme.props.border },
    "&:not(.timeline) .d1.descriptionRow": { borderColor: theme.props.border },
    "&.active:not(.d0) .cell, &:not(.d0):hover .cell": { borderColor: theme.palette.primary.main },
    "&.active:not(.d0) .descriptionRowContainer, &:not(.d0):hover .descriptionRowContainer": { borderColor: theme.palette.primary.main },
    "&.active:not(.d0) .descriptionRow, &:not(.d0):hover .descriptionRow": { borderColor: theme.palette.primary.main },

    // border widths
    // "& .cell, & .descriptionRowContainer, & .descriptionRow": { transition: "border-color .3s ease-out" },
    "& .top > .cell": { borderTopWidth: 1 },
    "& .bottom > .cell": { borderBottomWidth: 1 },
    
    "& .top": {
      borderTopLeftRadius: 5,
      borderTopRightRadius: 5,
    },
    "& .bottom": {
      borderBottomLeftRadius: 5,
      borderBottomRightRadius: 5,
    },
    
    "& .bottom.descriptionRowContainer > .descriptionRow": { borderBottomWidth: 1 },
    "& .bottom.descriptionRowContainer, & .bottom.descriptionRowContainer > .descriptionRow": {
      borderBottomLeftRadius: 5,
      borderBottomRightRadius: 5,
    },
    "& .bottom.descriptionRowContainer > .descriptionFiller": {
      borderBottomRightRadius: 5,
    },
    "& div[role='row'] > .cell:nth-child(1 of .cell)": { borderLeftWidth: 1 },
    "& div[role='row'] > .cell:nth-last-child(1 of .cell)": { borderRightWidth: 1 },
    // "&.active:not(.d0) div > .cell:nth-last-child(1 of .cell), &:not(.d0):hover .cell:nth-last-child(1 of .cell)": { borderRightColor: theme.palette.primary.main },
    // "&.active:not(.d0) div > .descriptionRow, &:not(.d0):hover .descriptionRow": { borderRightColor: theme.palette.primary.main },

    "& .top > .cell:nth-child(1 of .cell)": { borderTopLeftRadius: 5 },
    "& .bottom > .cell:nth-child(1 of .cell)": { borderBottomLeftRadius: 5 },
    "&:not(.timeline) .top > .cell:nth-last-child(1 of .cell)": { borderTopRightRadius: 5 },
    "&:not(.timeline) .bottom > .cell:nth-last-child(1 of .cell)": { borderBottomRightRadius: 5 },
    "&.active.timeline .top > .cell:nth-last-child(1 of .cell), &.timeline:hover .top > .cell:nth-last-child(1 of .cell)": { borderTopRightRadius: 5 },
    "&.active.timeline .bottom > .cell:nth-last-child(1 of .cell), &.timeline:hover .bottom > .cell:nth-last-child(1 of .cell)": { borderBottomRightRadius: 5 },
  },
  // noBottomBorders: {
  //   "& .bottom > .cell": { borderBottomWidth: 1 },
  // }
  bordered: {
    borderWidth: 2,
    borderStyle: "solid",
    borderColor: theme.props.border,
    "&.d1.active, &.d1:hover": {
      borderColor: theme.palette.primary.main
    },
    "&.d1": { borderRadius: 7 },
  },
  avoidPageBreaks: {
    breakInside: "avoid !important"
  }
}));

export default useStyle;
